export const getAppAccessTypeLink = (appInfo) => {
  let active = false;
  let url = "#";
  if (appInfo?.accessTypeLink) {
    active = true;
    url = appInfo.accessTypeLink;
  }
  return { active: active, url: url };
};
